import taxInfoNotification from '@/components/tax-info-notification/tax-info-notification.vue';

export default {
  components: {
    taxInfoNotification,
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/page-tax-detail/page-tax-detail.js